import React, { useRef } from 'react';
import { Button, Col, Form, Input, Row } from 'antd';
import Contact from '../../classes/contact';
import { FormInstance } from 'antd/lib/form';
import { ValidationPatterns } from '../../config/config';
import { useTranslation } from 'react-i18next';

const { emailPattern, telefonNumberPattern } = ValidationPatterns;
const twoColFormItemLayout = {
    wrapperCol: { span: 14 },
    labelCol: { span: 6 },
};

interface IProps {
    data: Contact;
    formIsValid: (isValid: boolean, values?: any) => void;
    nextStep: () => void;
}

const ContactForm = (props: IProps) => {
    const { t } = useTranslation();
    const formRef = useRef<FormInstance>(null);

    const onFinish = (values: any) => {
        if (document.getElementById('city-' + values.cityId) != null) {
            values.city = document.getElementById('city-' + values.cityId)!.getAttribute('data-city');
            values.provinceId = document.getElementById('city-' + values.cityId)!.getAttribute('data-province');
        }
        props.formIsValid(true, values);
        props.nextStep();
    };

    const onFinishFailed = () => {
        props.formIsValid(false);
    };

    return (
        <Form id="contact-form" className="center" ref={formRef} onFinish={onFinish} onFinishFailed={onFinishFailed}>
            <h2 className="font-weight-600 title-content">{t('sicuri&protetti.titles.title3')}</h2>
            <h5 className="font-weight-600 title_content">{t('sicuri&protetti.subtitles.subtitle0')}</h5>
            <Row>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Form.Item
                        {...twoColFormItemLayout}
                        name="firstname"
                        label={t('customerClass.firstname')}
                        initialValue={props.data.firstname}
                        rules={[
                            {
                                required: true,
                                message: t('errorMessages.firstnameReq'),
                            },
                        ]}
                    >
                        <Input placeholder={t('customerClass.firstname')} />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Form.Item
                        {...twoColFormItemLayout}
                        name="surname"
                        label={t('customerClass.surname')}
                        initialValue={props.data.surname}
                        rules={[
                            {
                                required: true,
                                message: t('errorMessages.surnameReq'),
                            },
                        ]}
                    >
                        <Input placeholder={t('customerClass.surname')} />
                    </Form.Item>
                </Col>
            </Row>
            <h5 className="font-weight-600 title_content">{t('sicuri&protetti.subtitles.subtitle2')}</h5>
            <Row>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Form.Item
                        {...twoColFormItemLayout}
                        name="tel1"
                        label={t('customerClass.tel1')}
                        initialValue={props.data.tel1}
                        rules={[
                            {
                                required: true,
                                message: t('errorMessages.telReq'),
                            },
                            {
                                pattern: telefonNumberPattern,
                                message: t('errorMessages.telReq'),
                            },
                        ]}
                    >
                        <Input placeholder={t('customerClass.tel1')} />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Form.Item
                        {...twoColFormItemLayout}
                        name="tel2"
                        label={t('customerClass.tel2')}
                        initialValue={props.data.tel2}
                        rules={[
                            {
                                pattern: telefonNumberPattern,
                                message: t('errorMessages.telReq'),
                            },
                        ]}
                    >
                        <Input placeholder={t('customerClass.tel2')} />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Form.Item
                        {...twoColFormItemLayout}
                        name="email"
                        label={t('customerClass.emailAddress')}
                        initialValue={props.data.email}
                        rules={[
                            {
                                required: true,
                                message: t('errorMessages.emailReq'),
                            },
                            {
                                pattern: emailPattern,
                                message: t('errorMessages.emailValid'),
                            },
                        ]}
                    >
                        <Input placeholder={t('customerClass.emailAddress')} />
                    </Form.Item>
                </Col>
            </Row>
            <Form.Item>
                <Button type="primary" htmlType="submit" id="contact-submit" hidden />
            </Form.Item>
        </Form>
    );
};

export default ContactForm;
